import { useContext } from 'react';
import { SignInEntityContext } from '@at/connected-signin';
import { useATTrackInteraction } from '@at/consumer-web-snowplow';
import { getCookieName } from '../util/cookie-utils';
export const useHeaderTrackingCallbacks = () => {
    const signInEntityContext = useContext(SignInEntityContext);
    const trackInteraction = useATTrackInteraction();
    return {
        onAccountClick: () => {
            signInEntityContext.onTrigger();
            trackInteraction({ trackingLabel: 'nav-account' });
        },
        onLogoClick: () => trackInteraction({ trackingLabel: 'nav-logo' }),
        onSellClick: () => trackInteraction({ trackingLabel: 'nav-sell-your-car-icon' }),
        onSearchClick: () => trackInteraction({ trackingLabel: 'nav-search' }),
        onSavedClick: () => trackInteraction({ trackingLabel: 'nav-saved' }),
        onNavigationClick: ({ labelIdentifier }) => {
            trackInteraction({
                trackingLabel: labelIdentifier,
            });
        },
    };
};
export const isUserSignedInFromCookie = () => {
    return getCookieName('ursid') != null;
};
export const buildAfterSignInUrl = (pathname, search) => {
    return encodeURIComponent(`${pathname}${search}`);
};
